import { useState } from 'react';
import { ArrowLeft, Mail, Edit, MoreHorizontal, Upload, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function InvoicesDetails() {
    const navigate = useNavigate();
    const [showMore, setShowMore] = useState(false);

    return (
        <div className="min-h-screen p-4 text-sm">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                {/* Header */}
                <div className="border-b border-gray-200 p-4 bg-gradient-to-b from-teal-50/20 to-white">
                    <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => navigate(-1)}
                                className="p-1.5 hover:bg-gray-100 rounded-lg transition"
                            >
                                <ArrowLeft className="w-5 h-5" />
                            </button>
                            <div>
                                <div className="flex items-center gap-2">
                                    <span className="px-2.5 py-1 bg-yellow-100 text-yellow-700 rounded-full text-xs font-medium">
                                        Draft
                                    </span>
                                    <h1 className="text-xl font-bold text-gray-900">Invoice #1</h1>
                                </div>
                                <p className="text-xs text-gray-600 mt-0.5">as</p>
                            </div>
                        </div>

                        <div className="flex items-center gap-2">
                            {/* More Actions */}
                            <div className="relative">
                                <button
                                    onClick={(e) => { e.stopPropagation(); setShowMore(!showMore); }}
                                    className="px-3 py-1.5 border border-gray-300 rounded-lg text-xs font-medium flex items-center gap-1.5"
                                >
                                    <MoreHorizontal className="w-4 h-4" />
                                    More
                                </button>
                                {showMore && (
                                    <>
                                        <div className="fixed inset-0 z-10" onClick={() => setShowMore(false)} />
                                        <div className="absolute right-0 top-full mt-1.5 w-48 bg-white rounded-lg shadow-xl border border-gray-200 z-20 text-xs">
                                            <button className="w-full text-left px-3 py-2 hover:bg-gray-50 flex items-center gap-1.5">
                                                <FileText className="w-4 h-4 text-gray-600" /> Duplicate
                                            </button>
                                            <button className="w-full text-left px-3 py-2 hover:bg-gray-50 flex items-center gap-1.5">
                                                <Upload className="w-4 h-4 text-gray-600" /> Export PDF
                                            </button>
                                            <button className="w-full text-left px-3 py-2 hover:bg-red-50 text-red-600 flex items-center gap-1.5">
                                                Delete
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>

                            <button className="px-3 py-1.5 bg-teal-600 text-white rounded-lg text-xs font-medium flex items-center gap-1.5 shadow-sm hover:shadow">
                                <Edit className="w-4 h-4" /> Edit
                            </button>

                            <button className="px-3 py-1.5 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-lg text-xs font-medium flex items-center gap-1.5 shadow-sm hover:shadow">
                                <Mail className="w-4 h-4" /> Send Email
                            </button>
                        </div>
                    </div>

                    {/* Client Info */}
                    <div className="grid grid-cols-2 gap-6 mt-4 text-xs">
                        <div>
                            <h3 className="font-medium text-gray-900 mb-1.5">Billing address</h3>
                            <p className="text-gray-700">sd ds sd, sd 12235</p>
                            <p className="text-xs text-gray-500 mt-0.5">Property Address (Same as billing address)</p>
                        </div>
                        <div>
                            <h3 className="font-medium text-gray-900 mb-1.5">Contact details</h3>
                            <p className="text-gray-700">0792019411</p>
                            <p className="text-xs text-gray-600">dd@gmail.com</p>
                        </div>
                    </div>

                    {/* Invoice Info */}
                    <div className="grid grid-cols-2 gap-4 mt-4 text-xs">
                        <div>
                            <span className="text-gray-500">1 Job</span>
                            <p className="font-medium mt-0.5">#1</p>
                        </div>
                        <div>
                            <span className="text-gray-500">Issued</span>
                            <p className="font-medium mt-0.5 text-orange-600">Not sent yet</p>
                        </div>
                        <div>
                            <span className="text-gray-500">Due</span>
                            <p className="font-medium mt-0.5">Net 30 days</p>
                        </div>
                        <div>
                            <span className="text-gray-500">Salesperson</span>
                            <div className="flex items-center gap-1.5 mt-0.5">
                                <div className="w-7 h-7 rounded-full bg-emerald-600 text-white flex items-center justify-center text-xs font-bold">
                                    Z
                                </div>
                                <span className="font-medium">Zaid</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Line Items */}
                <div className="p-4 border-b border-gray-200 bg-gradient-to-b from-white to-gray-50/20">
                    <h2 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-1.5">
                        <span className="w-1 h-6 bg-gradient-to-b from-teal-500 to-teal-600 rounded-full"></span>
                        Product / Service
                    </h2>

                    <div className="border border-gray-200 rounded-lg p-3 bg-white text-xs">
                        <div className="grid grid-cols-12 gap-3 mb-2">
                            <div className="col-span-6 font-medium">Free Assessment</div>
                            <div className="col-span-2 text-center">1</div>
                            <div className="col-span-2 text-right">$0.00</div>
                            <div className="col-span-2 text-right font-medium">$0.00</div>
                        </div>
                        <p className="text-xs text-gray-600 col-span-12">
                            Our experts will come to assess your needs and discuss solutions
                        </p>
                    </div>

                    {/* Totals */}
                    <div className="mt-4 flex justify-end">
                        <div className="w-64 space-y-1.5 text-xs">
                            <div className="flex justify-between py-1">
                                <span className="text-gray-700">Subtotal</span>
                                <span className="font-medium">$0.00</span>
                            </div>
                            <div className="flex justify-between py-1 border-t border-gray-300 font-medium text-sm">
                                <span>Total</span>
                                <span>$0.00</span>
                            </div>
                            <div className="flex justify-between py-1 text-teal-600">
                                <span>Account balance</span>
                                <span className="font-medium">(Including this draft) $0.00</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contract / Disclaimer */}
                <div className="p-4 border-b border-gray-200">
                    <h2 className="text-base font-medium text-gray-900 mb-1.5">Contract / Disclaimer</h2>
                    <p className="text-xs text-gray-700">
                        Thank you for your business. Please contact us with any questions regarding this invoice.
                    </p>
                </div>

                {/* Internal Notes */}
                <div className="p-4 border-b border-gray-200 bg-gray-50">
                    <h2 className="text-base font-medium text-gray-900 mb-1.5">Internal notes</h2>
                    <p className="text-xs text-gray-600 italic mb-2">
                        Internal notes will only be seen by your team
                    </p>
                    <textarea
                        placeholder="Add internal note..."
                        className="w-full p-2.5 border border-gray-300 rounded-lg resize-none focus:ring-1 focus:ring-teal-500 text-xs"
                        rows="2"
                    />
                </div>

                {/* Note Details */}
                <div className="p-4">
                    <h2 className="text-base font-medium text-gray-900 mb-3">Note details</h2>

                    {/* File Upload */}
                    <div className="border border-dashed border-gray-300 rounded-lg p-5 text-center mb-3">
                        <Upload className="w-8 h-8 text-gray-400 mx-auto mb-1.5" />
                        <p className="text-xs text-gray-600">
                            Drag files or <span className="text-teal-600 font-medium">select</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}